import { TimePicker } from "ant-design-vue";
import { toNumber } from "lodash";
import moment, { Moment } from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

export interface DurationSelectProps {
	isEdit?: boolean;
	isStart?: boolean;
	initValue?: string;
	className?: string;
	change?: (value) => void;
}

@Component({
	components: {
		TimePicker
	}
})
export default class DurationSelect extends Vue {
	@Prop({ default: false }) isEdit!: boolean;
	@Prop({ default: true }) isStart!: boolean;
	@Prop({ default: "03:00" }) initValue!: string;
	@Prop() block!: boolean;
	@Prop() className?: string;
	@Prop() wrapperClassName?: string;

	public value: Moment = moment();

	mounted() {
		this.value = this.defaultValue();
	}

	@Watch("initValue")
	changeValue() {
		this.value = this.defaultValue();
	}

	public defaultValue(): Moment {
		const date = moment().startOf("hour");
		let minutes: number = 3;
		let seconds: number = 30;

		if (this.initValue) {
			const [mm, ss] = this.initValue.split(":");
			minutes = toNumber(mm);
			seconds = toNumber(ss);
		} else if (this.isStart) {
			minutes = 3;
			seconds = 0;
		}

		date.set("minute", minutes);
		date.set("second", seconds);

		return date;
	}
	public get displayValue(): string {
		return this.defaultValue().format("mm:ss");
	}

	public getMinimumValue(): Moment {
		return moment().startOf("hour").set("minute", 0).set("second", 1);
	}

	public onDurationChange(value: Moment) {
		this.value = value;
		const formattedValue = value.format("mm:ss");

		if (formattedValue === "00:00") {
			this.value = this.getMinimumValue();
		}
		this.$emit("change", this.value.format("mm:ss"));
	}
}
